import React, { useEffect, useState, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../components/Sidebar/SidebarProvider";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Divider,
  LinearProgress,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import {
  getAllUsers,
  uploadDocumentoUsuario,
  getDocumentosUsuario,
  deleteDocumentoUsuario,
} from "../../api/User/userApi";

const API_URL = process.env.REACT_APP_API_URL;

const AdminUserDocuments = () => {
  const theme = useTheme();
  const { contentMargin } = useContext(SidebarContext);
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [docs, setDocs] = useState([]);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp < currentTime) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      navigate("/login");
    }
  }, [navigate, token]);

  // Cargar usuarios
  useEffect(() => {
    getAllUsers().then(setUsers).catch(console.error);
  }, []);

  // Cargar documentos cuando cambia usuario
  useEffect(() => {
    if (!selectedUser) return;
    getDocumentosUsuario(selectedUser).then(setDocs);
  }, [selectedUser]);

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file || !selectedUser) return;

    setUploading(true);
    try {
      await uploadDocumentoUsuario(selectedUser, file);
      const updated = await getDocumentosUsuario(selectedUser);
      setDocs(updated);
    } catch (e) {
      console.error(e);
    }
    setUploading(false);
  };

  const handleDelete = async (id) => {
    await deleteDocumentoUsuario(id);
    const updated = await getDocumentosUsuario(selectedUser);
    setDocs(updated);
  };

  return (
    <Card sx={{ ...contentMargin, mt: 4, p: 3 }}>
      <Typography variant="h5" fontWeight="bold">
        Administrar documentos de usuarios
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Selección de usuario */}
      <FormControl sx={{ minWidth: 300 }}>
        <InputLabel>Seleccionar usuario</InputLabel>
        <Select
          value={selectedUser}
          label="Seleccionar usuario"
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          {users
            .filter(
              (u) =>
                u.ACTIVO === "S" && // solo usuarios activos
                u.EMAIL &&
                u.EMAIL.trim() !== "" // solo emails válidos
            )
            .map((u) => (
              <MenuItem key={u.id} value={u.EMAIL}>
                {u.username} — {u.EMAIL}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      {selectedUser && (
        <>
          <Divider sx={{ my: 3 }} />

          {/* SUBIR DOCUMENTO */}
          <Button
            variant="contained"
            component="label"
            startIcon={<UploadFileIcon />}
          >
            Subir documento PDF
            <input
              type="file"
              hidden
              accept="application/pdf"
              onChange={handleUpload}
            />
          </Button>

          {uploading && <LinearProgress sx={{ mt: 2 }} />}

          <Divider sx={{ my: 3 }} />

          {/* LISTADO DE DOCUMENTOS */}
          <Typography variant="h6" sx={{ mb: 2 }}>
            Documentos subidos
          </Typography>

          {docs.length === 0 && <Typography>No hay documentos.</Typography>}

          {docs.map((d) => (
            <Card key={d.id} sx={{ mb: 2, p: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography>{d.nombreDocumento}</Typography>

                <Box>
                  <Button
                    href={`${API_URL}/api/user-documents/view-public/${
                      d.id
                    }?token=${localStorage.getItem("token")}`}
                    target="_blank"
                    variant="outlined"
                  >
                    Ver
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    href={`${API_URL}/api/user-documents/${
                      d.id
                    }/download-signed?token=${localStorage.getItem("token")}`}
                    sx={{ ml: 1 }}
                  >
                    Descargar
                  </Button>

                  <IconButton
                    color="error"
                    onClick={() => handleDelete(d.id)}
                    sx={{ ml: 1 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </Box>
            </Card>
          ))}
        </>
      )}
    </Card>
  );
};

export default AdminUserDocuments;
